var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBasketball(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.68 76.32a48.2 48.2 0 0 0 7.96-17.16c-5.64.88-10.88 3-15.4 6.12 2.64 3.56 5.12 7.28 7.44 11.04m-23.56 17.2c6.84-2.28 12.96-6.04 18.04-10.88-2.48-4.16-5.12-8.24-8-12.12-5.72 6.12-9.44 14.12-10 23zm8.72-76.96c0 11.04-3.6 21.24-9.68 29.56 4.28 4.08 8.32 8.36 12.08 12.92 6.24-4.4 13.6-7.24 21.6-8.04.08-1 .16-1.96.16-3 0-18.32-10.28-34.24-25.36-42.32.76 3.52 1.2 7.16 1.2 10.88m-58.32-1.88c15.68 6.36 30.12 15.16 42.72 26.04 4.8-6.84 7.6-15.16 7.6-24.16 0-5.16-.96-10.12-2.68-14.68C56.96.68 52.56 0 48 0 34.44 0 22.24 5.64 13.52 14.68m8 52.24c-6.76 0-13.16-1.36-19.04-3.76C8.84 82.24 26.8 96.04 48 96.04c2.4 0 4.72-.24 7.04-.56.16-12.16 5.12-23.2 13.12-31.28-3.48-4.2-7.2-8.16-11.12-11.92-9.12 9.08-21.64 14.68-35.48 14.68z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.08 46.84A145.9 145.9 0 0 0 8.24 21.16C3.04 28.8 0 38.04 0 48c0 1.72.12 3.44.28 5.12 6.24 3.64 13.48 5.76 21.24 5.76 11.48 0 21.92-4.6 29.56-12.08z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasketball);
export default __webpack_public_path__ + "static/media/basketball.920ea1eedfbc06071901de4c26ac2c2b.svg";
export { ForwardRef as ReactComponent };